import { token } from '@atlaskit/tokens';

type IconProps = {
	width?: string | number;
	height?: string | number;
};

export const BillingIcon = ({ width = '24', height = '24' }: IconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="2"
				y="2"
				width="24"
				height="24"
				rx="12"
				fill={token('elevation.surface.sunken')}
				fillOpacity="0.07"
			/>
			<rect
				x="1"
				y="1"
				width="26"
				height="26"
				rx="13"
				stroke={token('color.border.accent.gray')}
				strokeOpacity="0.4"
				strokeWidth="1"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 8.5C8.72386 8.5 8.5 8.72386 8.5 9V9.49994H19C20.1046 9.49994 21 10.3954 21 11.4999V18.9999C21 20.1045 20.1046 20.9999 19 20.9999H9C7.89543 20.9999 7 20.1045 7 18.9999V9C7 7.89543 7.89543 7 9 7H19.5V8.5H9ZM8.5 10.9999V18.9999C8.5 19.2761 8.72386 19.4999 9 19.4999H19C19.2761 19.4999 19.5 19.2761 19.5 18.9999V17.5H18C16.8954 17.5 16 16.6046 16 15.5V15C16 13.8954 16.8954 13 18 13H19.5V11.4999C19.5 11.2238 19.2761 10.9999 19 10.9999H8.5ZM19.5 14.5H18C17.7239 14.5 17.5 14.7239 17.5 15V15.5C17.5 15.7761 17.7239 16 18 16H19.5V14.5Z"
				fill={token('color.icon.accent.gray')}
			/>
		</svg>
	);
};
